import { ProductList, ProductEdit } from './pages';
import Paths from './paths';
import { default as Translations } from './lang/hu';

export default {
    pages: {
        ProductList,
        ProductEdit,
    },
    paths: {
        ...Paths,
    },
    translations: {
        ...Translations,
    },
    name: 'product',
    icon: 'fa-shopping-cart',
};

export { default as Paths } from './paths';



// WEBPACK FOOTER //
// ./src/modules/Product/index.ts